function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import deepEqual from 'fast-deep-equal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { dhNewCircleLargeFilled, vsTrash } from '@deephaven/icons';
import { Button, Select } from '@deephaven/components';
import Log from '@deephaven/log';
import "./SelectDistinctBuilder.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('SelectDistinctBuilder');
class SelectDistinctBuilder extends Component {
  constructor(props) {
    super(props);
    this.handleAddColumnClick = this.handleAddColumnClick.bind(this);
    this.handleDeleteColumn = this.handleDeleteColumn.bind(this);
    this.handleDropdownChanged = this.handleDropdownChanged.bind(this);
    var _this$props = this.props,
      model = _this$props.model,
      selectDistinctColumns = _this$props.selectDistinctColumns;
    this.state = {
      inputs: selectDistinctColumns.length > 0 ? [...selectDistinctColumns] : [''],
      columns: model.originalColumns
    };
  }
  componentDidUpdate(prevProps, prevState) {
    var inputs = this.state.inputs;
    var onChange = this.props.onChange;
    if (prevState.inputs !== inputs) {
      var filteredInputs = inputs.filter(val => val !== '');
      if (!deepEqual(prevState.inputs.filter(val => val !== ''), filteredInputs)) {
        onChange(filteredInputs);
      }
    }
  }
  handleAddColumnClick() {
    this.setState(_ref => {
      var prevInputs = _ref.inputs;
      return {
        inputs: [...prevInputs, '']
      };
    });
  }
  handleDeleteColumn(index) {
    this.setState(_ref2 => {
      var inputs = _ref2.inputs;
      return {
        inputs: inputs.length === 1 && index === 0 ? [''] : inputs.filter((input, inputIndex) => index !== inputIndex)
      };
    });
  }
  handleDropdownChanged(index, value) {
    log.debug('handleDropdownChanged', index, value);
    this.setState(_ref3 => {
      var prevInputs = _ref3.inputs;
      var inputs = [...prevInputs];
      inputs[index] = value;
      return {
        inputs
      };
    });
  }
  renderInputs() {
    var _this$state = this.state,
      columns = _this$state.columns,
      inputs = _this$state.inputs;
    return inputs.map((value, index) => {
      var options = columns.filter(_ref4 => {
        var name = _ref4.name;
        return name === value || !inputs.includes(name);
      }).map(_ref5 => {
        var name = _ref5.name;
        return /*#__PURE__*/_jsx("option", {
          value: name,
          children: name
        }, name);
      });
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        _jsxs("div", {
          className: "form-inline px-3 pb-3",
          children: [/*#__PURE__*/_jsxs(Select, {
            className: "form-control custom-select col",
            value: value,
            onChange: eventTargetValue => this.handleDropdownChanged(index, eventTargetValue),
            children: [/*#__PURE__*/_jsx("option", {
              value: "",
              children: "Select a column"
            }), options]
          }), (inputs.length > 1 || value !== '') && /*#__PURE__*/_jsx(Button, {
            kind: "ghost",
            className: "ml-1 px-2",
            onClick: () => {
              this.handleDeleteColumn(index);
            },
            icon: /*#__PURE__*/_jsx(FontAwesomeIcon, {
              icon: vsTrash,
              transform: "grow-3"
            }),
            tooltip: "Delete column"
          })]
        }, index)
      );
    });
  }
  render() {
    var _this$state2 = this.state,
      columns = _this$state2.columns,
      inputs = _this$state2.inputs;
    var disableAddButton = inputs.length >= columns.length;
    return /*#__PURE__*/_jsxs("div", {
      role: "presentation",
      className: "select-distinct-builder-container h-100",
      children: [/*#__PURE__*/_jsx("div", {
        className: "select-distinct-title",
        children: "Display Unique Values From"
      }), this.renderInputs(), /*#__PURE__*/_jsx("hr", {}), /*#__PURE__*/_jsx("div", {
        className: "pt-1 px-3",
        children: /*#__PURE__*/_jsx(Button, {
          kind: "ghost",
          className: "btn-add-column",
          onClick: this.handleAddColumnClick,
          disabled: disableAddButton,
          icon: dhNewCircleLargeFilled,
          children: "Add Additional Column"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "select-distinct-builder-footer",
        children: /*#__PURE__*/_jsx("div", {
          className: "select-distinct-builder-hint",
          children: "Display only unique values from the selected table columns. Note that this will reset any filters and display only the selected columns."
        })
      })]
    });
  }
}
_defineProperty(SelectDistinctBuilder, "defaultProps", {
  selectDistinctColumns: [],
  onChange: () => undefined
});
export default SelectDistinctBuilder;
//# sourceMappingURL=SelectDistinctBuilder.js.map